import React, { useState } from "react";
import { styled } from "@phntms/css-components";
import Link from "next/link";
import styles from "./styles.module.scss";

const StyledBar = styled("div", {
  css: styles.announcementBar,
  variants: {
    isClickable: {
      true: styles.clickable,
    },
  },
});

const StyledLink = styled(Link, {
  css: styles.announcementBar,
  variants: {
    isClickable: {
      true: styles.clickable,
    },
  },
});

const CloseButton = styled("button", {
  css: styles.closeButton,
});

export interface AnnouncementBarProps {
  content: string; //html content
  link?: {
    url: string;
    target?: string;
  };
}

export const AnnouncementBar: React.FC<AnnouncementBarProps> = ({
  content,
  link,
}) => {
  const [isVisible, setIsVisible] = useState(true);
  const isClickable = !!link?.url;

  if (!isVisible) return null;

  const handleClose = (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    setIsVisible(false);
  };

  if (isClickable) {
    return (
      <StyledLink href={link.url} target={link.target} isClickable={true}>
        <div dangerouslySetInnerHTML={{ __html: content }} />
        <CloseButton onClick={handleClose} aria-label="Close announcement">
          <span>&times;</span>
        </CloseButton>
      </StyledLink>
    );
  }

  return (
    <StyledBar isClickable={false}>
      <div dangerouslySetInnerHTML={{ __html: content }} />
      <CloseButton onClick={handleClose} aria-label="Close announcement">
        <span>&times;</span>
      </CloseButton>
    </StyledBar>
  );
};
